export const getEqualSubstring = (str1: string, str2: string) => {
  for (let i = Math.min(str1.length, str2.length) - 1; i > 0; i -= 1) {
    const substr1 = str1.substr(0, i);
    if (substr1 === str2.substr(0, i)) {
      return substr1;
    }
  }
  return "";
};
